import type { scenes } from '@padcanvas/shared';
import { AGREEMENT_MARK, TRUST_HINT } from './sceneLabels';

export function TrustPill({ trust }: { trust: scenes.Trust }) {
    return <span className={`scn-pill scn-trust--${trust}`} title={TRUST_HINT[trust]}>{trust}</span>;
}

export function ConfidencePill({ confidence }: { confidence?: scenes.Confidence }) {
    if (!confidence) return <span className="scn-dim">—</span>;
    return <span className={`scn-pill scn-conf--${confidence}`}>{confidence}</span>;
}

/** ✓✓✗ — one mark per ask, in ask order. */
export function AgreementMarks({ agreement }: { agreement: scenes.Agreement[] }) {
    if (agreement.length === 0) return <span className="scn-dim">—</span>;
    return (
        <span className="scn-marks" title={agreement.join(', ')}>
            {agreement.map((a, i) => <span key={i} className={`scn-mark--${a}`}>{AGREEMENT_MARK[a]}</span>)}
        </span>
    );
}
